module.exports = __webpack_public_path__ + "img/mishkafaim_yes.6bbd9b62.png";